// Components
import { wrap } from "svelte-spa-router/wrap";
import Creator from "./pages/Creator.svelte";
import Login from "./pages/Login.svelte";
import LoginOffline from "./pages/LoginOffline.svelte";
import Offline from "./pages/Offline.svelte";
import Signup from "./pages/Signup.svelte";

// Firebase
import { auth, functions } from "./configs/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import online from "./configs/status.js";
let activationToken = localStorage.getItem("cc-offline-license");

/* Check User Status */
function getCurrentUser(auth) {
	return new Promise((resolve, reject) => {
		const unsubscribe = onAuthStateChanged(auth, (user) => {
			unsubscribe();
			resolve(user);
		}, reject);
	});
}


// Export the route definition object
export default {
	// Exact path
	"/": wrap({
		component: Creator,
		conditions: [
			async () => {
                if (online) {                  
					let user = await getCurrentUser(auth);
					if (user) {
						return true;
					} else {
						return false;
					}
				} else if (window.self !== window.top){
                    return true;
                } else if (!online && activationToken) {
                    return true;
				} else {
                    return false;
                }
			},
		],
	}),

	"/login": wrap({
		component: Login,
		conditions: [
			async () => {
                if (!online){
                    return false;
                }            
                
                if (online) {
					let user = await getCurrentUser(auth);
					if (user) {
						return false;
					} else {
						return true;
					}
				} else {
                    return false;
                }
			},
		],
	}),
    "/loginOffline": wrap({
		component: LoginOffline,
		conditions: [
			async () => {
                if (window.self !== window.top){
                    return false;
                } else if (online) {
					return false;
				} else {
                    if (activationToken) {
						return false;
					} else {
						return true;
					}
                }
			},
		],
	}),
	"/signup": wrap({
		component: Signup,
		conditions: [
			async () => {
				// Only allow access if online
				if (!online) {
					return false;
				}

				// Check if user is authenticated
				let user = await getCurrentUser(auth);
				if (!user) {
					return false;
				}

				// Check if user already has a subscription
				try {
					const email = user.email;
					const getAuthInfoRes = await httpsCallable(functions, "v8UserAuthV3")(email);
					
					const subscriptionList = getAuthInfoRes.data.subscriptions.list;
					
					// If user has subscription, redirect to main app
					if (subscriptionList.length > 0) {
						// User has subscription, redirect to /
						window.location.hash = "/";
						return false;
					}
					
					// User has no subscription, allow access to signup
					return true;
				} catch (error) {
					console.error("Error checking subscription:", error);
					// On error, allow access to signup page
					return true;
				}
			},
		],
	}),
    "/offline": wrap({
		component: Offline,
		conditions: [
			async () => {
                if (window.self !== window.top){
                    return false;
                } else if (online) {
					return false;
				} else {
                    return true;
                }
			},
		],
	}),
};
